import { Routes, mapToCanActivate } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { LocationGuard } from '@next/core-lib/relationships';

import { DairyOverviewComponent } from './dairyresults/components/dairy-overview/dairy-overview.component';
import { IndividualProductionComponent } from './dairyresults/components/individual-production/individual-production.component';
import { MilkDeliveryComponent } from './dairyresults/components/milk-delivery/milk-delivery.component';
import { MilkDeliveryMonthSummaryComponent } from './dairyresults/components/milk-delivery-month-summary/milk-delivery-month-summary.component';
import { ProductionComponent } from './dairyresults/components/production/production.component';
import { EconomyComponent } from './economy/economy.component';
import { DeliveriesComponent } from './feed/components/deliveries/deliveries.component';
import { RationsComponent } from './feed/components/rations/rations.component';
import { SilageResultsComponent } from './feed/components/silage-results/silage-results.component';
import { FertilitySummaryComponent } from './fertility/components/fertility-summary/fertility-summary.component';
import { IndividualFertilityComponent } from './fertility/components/individual-fertility/individual-fertility.component';
import { HealthSummaryComponent } from './health/components/health-summary/health-summary.component';
import { SomaticCellCountAttentionsComponent } from './health/components/somatic-cell-count-attentions/somatic-cell-count-attentions.component';
import { HomepageComponent } from './homepage/homepage.component';
import { Co2DeliveriesComponent } from './sustainability/components/co2-deliveries/co2-deliveries.component';
import { Co2ExampleCompanyComponent } from './sustainability/components/co2-example-company/co2-example-company.component';
import { SustainabilityComponent } from './sustainability/components/sustainability/sustainability.component';
import { TechnicalResultComponent } from './technical-result/components/technical-result/technical-result.component';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'home',
    component: HomepageComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'economy',
    component: EconomyComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'overview',
    component: DairyOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'production',
    component: ProductionComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'individual-production',
    component: IndividualProductionComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'milk-delivery',
    component: MilkDeliveryComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'month-summary',
    component: MilkDeliveryMonthSummaryComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'rations',
    component: RationsComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'silage-results',
    component: SilageResultsComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'deliveries',
    component: DeliveriesComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'individual-fertility',
    component: IndividualFertilityComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'fertility-summary',
    component: FertilitySummaryComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'individual-health',
    component: SomaticCellCountAttentionsComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'health-summary',
    component: HealthSummaryComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'sustainability',
    component: SustainabilityComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'co2-deliveries',
    component: Co2DeliveriesComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'co2-example-company',
    component: Co2ExampleCompanyComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  {
    path: 'technical-result',
    component: TechnicalResultComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  ...coreRoutes,
];
